import { Component } from '@angular/core';
import { ORCIDServiceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Services') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidservice-form',
    templateUrl: './orcidservice.form.component.html'
})
export class ORCIDServiceFormComponent extends BaseFormComponent {
    public record!: ORCIDServiceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

